import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNav.css';
import AddIncomeModal from './AddIncomeModal';
import AddExpenseModal from './AddExpenseModal';

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showActions, setShowActions] = useState(false);
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [showIncomeModal, setShowIncomeModal] = useState(false);
  const [showExpenseModal, setShowExpenseModal] = useState(false);

  const isActive = (paths) => {
    if (Array.isArray(paths)) {
      return paths.some(path => location.pathname === path || location.pathname.startsWith(path + '/'));
    }
    return location.pathname === paths || location.pathname.startsWith(paths + '/');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    navigate('/login');
  };

  return (
    <>
      {/* Floating Action Button */}
      <div className={`fab-container ${showActions ? 'active' : ''}`}>
        {showActions && (
          <div className="fab-actions">
            <button 
              className="fab-action income"
              onClick={() => {
                setShowActions(false);
                setShowIncomeModal(true);
              }}
            >
              <span>💰</span>
              <span className="fab-label">Income</span>
            </button>
            <button 
              className="fab-action expense"
              onClick={() => {
                setShowActions(false);
                setShowExpenseModal(true);
              }}
            >
              <span>💸</span>
              <span className="fab-label">Expense</span>
            </button>
          </div>
        )}
        <button 
          className={`fab-main ${showActions ? 'active' : ''}`}
          onClick={() => setShowActions(!showActions)}
        >
          {showActions ? '✕' : '+'}
        </button>
      </div>

      {/* Bottom Navigation - 4 items + More */}
      <nav className="bottom-nav">
        <button
          className={`bottom-nav-item ${isActive('/home') ? 'active' : ''}`}
          onClick={() => navigate('/home')}
        >
          <span className="bottom-nav-icon">🏡</span>
          <span className="bottom-nav-label">Home</span>
        </button>

        <button
          className={`bottom-nav-item ${isActive(['/analytics', '/transactions', '/recurring', '/wallets', '/reports']) ? 'active' : ''}`}
          onClick={() => navigate('/analytics')}
        >
          <span className="bottom-nav-icon">💰</span>
          <span className="bottom-nav-label">Money</span>
        </button>

        {/* Spacer for FAB */}
        <div className="bottom-nav-fab-spacer"></div>

        <button
          className={`bottom-nav-item ${isActive(['/households', '/household']) ? 'active' : ''}`}
          onClick={() => navigate('/households')}
        >
          <span className="bottom-nav-icon">🏠</span>
          <span className="bottom-nav-label">Household</span>
        </button>
        
        {/* More Menu Button */}
        <button
          className={`bottom-nav-item ${showMoreMenu ? 'active' : ''}`}
          onClick={() => setShowMoreMenu(!showMoreMenu)}
        >
          <span className="bottom-nav-icon">☰</span>
          <span className="bottom-nav-label">More</span>
        </button>
      </nav>

      {/* More Menu Popup */}
      {showMoreMenu && (
        <>
          <div className="more-menu-overlay" onClick={() => setShowMoreMenu(false)} />
          <div className="more-menu">
            {/* Money Section */}
            <div className="more-menu-section-title">💰 Money</div>
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/transactions');
              }}
            >
              <span className="more-menu-icon">📋</span>
              <span>Transactions</span>
            </button>
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/recurring');
              }}
            >
              <span className="more-menu-icon">🔄</span>
              <span>Recurring</span>
            </button>
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/wallets');
              }}
            >
              <span className="more-menu-icon">💳</span>
              <span>Wallets</span>
            </button>
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/reports');
              }}
            >
              <span className="more-menu-icon">📑</span>
              <span>Reports</span>
            </button>

            <div className="more-menu-divider" />

            {/* Work Section */}
            <div className="more-menu-section-title">💼 Work</div>
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/employment');
              }}
            >
              <span className="more-menu-icon">🏢</span>
              <span>Employment</span>
            </button>
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/timeoff');
              }}
            >
              <span className="more-menu-icon">🏖️</span>
              <span>Time Off</span>
            </button>

            <div className="more-menu-divider" />

            {/* Settings & Logout */}
            <button 
              className="more-menu-item"
              onClick={() => {
                setShowMoreMenu(false);
                navigate('/settings');
              }}
            >
              <span className="more-menu-icon">⚙️</span>
              <span>Settings</span>
            </button>
            <button 
              className="more-menu-item logout"
              onClick={() => {
                setShowMoreMenu(false);
                handleLogout();
              }}
            >
              <span className="more-menu-icon">🚪</span>
              <span>Logout</span>
            </button>
          </div>
        </>
      )}

      {/* Modals */}
      {showIncomeModal && (
        <AddIncomeModal 
          onClose={() => {
            setShowIncomeModal(false);
            window.location.reload();
          }} 
        />
      )}

      {showExpenseModal && (
        <AddExpenseModal 
          onClose={() => {
            setShowExpenseModal(false);
            window.location.reload();
          }} 
        />
      )}

      {/* Overlay when FAB is open */}
      {showActions && (
        <div className="fab-overlay" onClick={() => setShowActions(false)} />
      )}
    </>
  );
}

export default BottomNav;
